import 'react-phone-input-2/lib/style.css'

import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import useForm from 'hooks/useForm'
import PhoneInput from 'react-phone-input-2'
import { useToasts } from 'react-toast-notifications'

import { contentCategories } from './constants'
import styles from './ExternalSmsDialog.module.scss'

const ExternalSmsDialog = ({
  handleClose,
  sentTestSmsToAnotherNumber,
  category,
  OTAVariantCategory,
  isTestSmsLoading
}) => {
  const { addToast } = useToasts()

  const [formData, handleFormChange, setFormData] = useForm({
    contentCategory: contentCategories.directGuestVariant,
    phoneNumber: '',
    guestName: ''
  })

  function handlePhoneChange(value) {
    setFormData({ ...formData, phoneNumber: value })
  }

  const handleFormSubmission = () => {
    if (Object.values(formData).some(value => !value.trim())) {
      addToast(`All fields are required.`, { appearance: 'error' })
      return
    }
    const nameRegex = /^[A-Za-z]+(?: [A-Za-z]+)+$/
    if (nameRegex.test(formData.guestName)) {
      sentTestSmsToAnotherNumber({
        ...formData,
        contentCategory:
          formData.contentCategory === contentCategories.directGuestVariant
            ? category
            : OTAVariantCategory
      })
    } else {
      addToast(`It is required to enter full name`, { appearance: 'error' })
    }
  }

  return (
    <ConfirmationDialog
      title="Test after last visit"
      positiveMessage={isTestSmsLoading ? 'Sending text message...' : 'Send text message'}
      onConfirm={handleFormSubmission}
      onClose={handleClose}
      actLikeForm={true}
      isButtonDisabled={isTestSmsLoading}
      theme="blacklist"
    >
      <div className={styles.formContainer}>
        <div className={styles.inputContainer}>
          <Dropdown
            label="Content category"
            name="contentCategory"
            value={formData.contentCategory}
            onChange={e => setFormData({ ...formData, contentCategory: e.target.value })}
            options={contentCategories}
            disabled={isTestSmsLoading}
            className={styles.formInput}
            required
          ></Dropdown>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.phoneLabel}>Cell phone number</p>
          <PhoneInput
            value={formData.phoneNumber}
            onChange={handlePhoneChange}
            inputStyle={{ width: '100%' }}
            containerStyle={{ marginBottom: '20px' }}
            defaultCountry="us"
            placeholder="Phone number"
            inputExtraProps={{
              autoComplete: 'off'
            }}
            disabled={isTestSmsLoading}
            className={styles.formInput}
            required
          />
        </div>
        <div className={styles.inputContainer}>
          <TextInput
            name="guestName"
            className={styles.formInput}
            type="string"
            label="Full name"
            value={formData.guestName}
            onChange={handleFormChange}
            disabled={isTestSmsLoading}
            required
          />
        </div>
      </div>
    </ConfirmationDialog>
  )
}

export default ExternalSmsDialog
